import type { SelectOptions } from '../types'
import type { PaymentProduct } from '../PaymentProducts/types'

export const createPaymentProductOptions = (
	paymentProducts: PaymentProduct[],
): SelectOptions[] => {
	let paymentProductOptions: SelectOptions[] = []
	if (paymentProducts && paymentProducts.length > 0) {
		paymentProductOptions = paymentProducts.map((p: PaymentProduct) => {
			return {
				label: p.name,
				value: p.uuid,
			}
		})
	}
	return paymentProductOptions
}
